module.exports = "//static.hsappstatic.net/academy-public-ui/static-1.8457/images/hubspot-academy-logo-color.svg"